import React, { Component } from 'react';
import './CreatorUploadMonetizationForm.css';
import CreatorMonetizationRoyaltyLiquidForm from './CreatorMonetizationRoyaltyLiquidForm';
import CreatorMonetizationMintPriceLiquidForm from './CreatorMonetizationMintPriceLiquidForm';

class CreatorUploadMonetizationLiquidForm extends Component {
  render() {
    return (
      <div>
        <CreatorMonetizationMintPriceLiquidForm
          usdPrice={this.props.usdPriceETH}
          checkString={this.props.checkString}
          checkStringWithDecimal={this.props.checkStringWithDecimal}
          setMintPrice={this.props.setMintPrice}
          setCurve={this.props.setCurve}
          setInterceptPolynomial={this.props.setInterceptPolynomial}
          setLinearTermPolynomial={this.props.setLinearTermPolynomial}
          setQuadraticTermPolynomial={this.props.setQuadraticTermPolynomial}
          setSigmoidGrowth={this.props.setSigmoidGrowth}
          setSigmoidPriceRange={this.props.setSigmoidPriceRange}
          setSigmoidInflectionPoint={this.props.setSigmoidInflectionPoint}
          setSigmoidCurveAdjustment={this.props.setSigmoidCurveAdjustment}
          params={this.props.params}
        />
        {
          this.props.shouldSetRoyalty
            ?
          <CreatorMonetizationRoyaltyLiquidForm
            checkString={this.props.checkString}
            setRoyalty={this.props.setRoyalty}
            params={this.props.params}
          />
            :
          null
        }
      </div>
    );
  }
}

export default CreatorUploadMonetizationLiquidForm;
